export default {
  name: "App",
  components: {},
  setup() {
    //
  },
};
